const initialState = {
  isLoadingSettings: false,
  settingsAllLoaded: false,
  managerNavFavorites: ['SCHEDULE', 'ATTENDANCES', 'TIME_OFFS', 'AVAILABILITIES', 'USER_LIST'],
  schedulerCollapsedResources: { noProject: true, noTeam: true },
  currentScheduleView: 'weekly',
  nightView: false,
  defaultTimeZone: 'America/Montreal'
}

const settings = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_IS_LOADING_SETTINGS':
      return { ...state, isLoadingSettings: true, settingsAllLoaded: false, lastRefreshedAt: new Date() }
    case 'SET_SETTINGS':
      return { ...state, ...action.settings, isLoadingSettings: false, settingsAllLoaded: true }
    case 'SET_SETTING_VALUE':
      return { ...state, [action.name]: action.value }

    case 'SET_LOGGED_OUT':
      return { ...initialState }
    default:
      return state
  }
}

export default settings
